import { utils, types } from '@credit/promotion-cl-sdk';

export function initPromotionSdk() {
  console.info('promotion sdk ready', BIZ_COUNTRY, REACT_APP_ENV);
  try {
    utils.sdkReady({
      region: BIZ_COUNTRY,
      env: REACT_APP_ENV as any,
      // 产品 bizType：SDK 拉 remote config 时作为 x-kredit-req-biz-type 头，缺省会按 Buyer=1
      productBizType: types.BIZ_TYPE.FastEscrow,
    });
  } catch (error) {
    console.error('promotion sdk ready error', error);
  }
}
